import '@grafana/ui';
import 'react';
import '@grafana/data';
import 'uuid';
import '@grafana/runtime';
import '../utils/debugger.js';
import { getStandardSQLCompletionProvider } from './standardSQLCompletionItemProvider.js';

const standardSQLLanguageDefinition = {
  id: "standardSql",
  extensions: [".sql"],
  aliases: ["sql"],
  mimetypes: [],
  loader: () => require("./language"),
  completionProvider: getStandardSQLCompletionProvider
};

export { standardSQLLanguageDefinition as default };
//# sourceMappingURL=definition.js.map
